import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b9fd584"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "text-truncate" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  title: "This email is locked."
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "btn btn-icon btn-dark btn-circle btn-sm" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" })
], -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_VZSideDrawer = _resolveComponent("VZSideDrawer")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_CreateEditEmailConfig = _resolveComponent("CreateEditEmailConfig")!
  const _component_ActivityModal = _resolveComponent("ActivityModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      defaultFilter: _ctx.defaultFilter,
      tableFilter: _ctx.tableFilter,
      bulkDelete: _ctx.bulkDelete,
      tableForm: _ctx.formData,
      activityTab: false,
      addButtonText: `${_ctx.t('pages.email.emailConfig.addEmail')}`,
      viewName: "emailConfigs",
      onTableRowClick: _ctx.tableRowClick,
      onQueryUpdate: _ctx.queryUpdate,
      onFormSubmit: _ctx.submit,
      onBulkDelete: _ctx.onBulkDelete,
      permissions: _ctx.permissionModel,
      customForm: true,
      onCustomForm: _cache[0] || (_cache[0] = ($event: any) => (_ctx.customForm())),
      ref: "datatable"
    }, {
      "cell-name": _withCtx(({ row: email }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(email?.name), 1)
      ]),
      "cell-emailProviderCodeText": _withCtx(({ row: email }) => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(email.emailProviderCodeText), 1)
      ]),
      "cell-hostName": _withCtx(({ row: email }) => [
        _createElementVNode("span", {
          class: "text-truncate",
          title: email?.data?.hostName
        }, _toDisplayString(email?.data?.hostName), 9, _hoisted_3)
      ]),
      "cell-portNo": _withCtx(({ row: email }) => [
        _createElementVNode("span", {
          class: "text-truncate",
          title: email.data.portNo
        }, _toDisplayString(email.data.portNo), 9, _hoisted_4)
      ]),
      "cell-email": _withCtx(({ row: email }) => [
        _createElementVNode("span", {
          class: "text-truncate",
          title: email.data.email
        }, _toDisplayString(email.data.email), 9, _hoisted_5)
      ]),
      "cell-startDate": _withCtx(({ row: email }) => [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.format.convertUTCToLocalDate(email.startDate)), 1)
      ]),
      "cell-status": _withCtx(({ row: email }) => [
        _createElementVNode("span", {
          class: _normalizeClass(["text-truncate fw-bolder", {
          'badge badge-success': email.status?.toLowerCase() === 'active',
          'badge badge-danger': email.status?.toLowerCase() !== 'active',
        }])
        }, _toDisplayString(_ctx.format.TitleCase(email.status?.toLowerCase())), 3)
      ]),
      "cell-actions": _withCtx(({ row: email }) => [
        (!email.lock)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
              (_ctx.hasPermission(_ctx.permissionModel.update))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _withModifiers(($event: any) => (_ctx.editLookup(email)), ["stop"]),
                    class: "btn btn-icon btn-primary btn-circle btn-sm"
                  }, _hoisted_10, 8, _hoisted_8))
                : _createCommentVNode("", true),
              (_ctx.hasPermission(_ctx.permissionModel.delete))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: _withModifiers(
            () => {
              _ctx.showDeleteDialog = true;
              _ctx.selectedForAction = email;
            }
          , ["stop"]),
                    class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
                  }, _hoisted_13, 8, _hoisted_11))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (email.lock)
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "tableFilter", "bulkDelete", "tableForm", "addButtonText", "onTableRowClick", "onQueryUpdate", "onFormSubmit", "onBulkDelete", "permissions"]),
    _createVNode(_component_VZSideDrawer, {
      modelValue: _ctx.openDrawer,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.openDrawer) = $event)),
      title: _ctx.sideDrawerTitle,
      icon: _ctx.sideDrawerIcon,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDrawer = false)),
      tabs: _ctx.tabs
    }, null, 8, ["modelValue", "title", "icon", "tabs"]),
    (_ctx.hasPermission(_ctx.permissionModel.delete))
      ? (_openBlock(), _createBlock(_component_VZDeleteModal, {
          key: 0,
          viewName: "emailConfigs",
          selectedForAction: [_ctx.selectedForAction.webId],
          deleteText: `${_ctx.t('validation.sureToDelete')} ${_ctx.selectedForAction.name}?`,
          onClose: _ctx.refreshList,
          showDialog: _ctx.showDeleteDialog,
          pageName: "email",
          onBulkDelete: _ctx.onBulkDelete
        }, null, 8, ["selectedForAction", "deleteText", "onClose", "showDialog", "onBulkDelete"]))
      : _createCommentVNode("", true),
    (_ctx.hasPermission(_ctx.permissionModel.create))
      ? (_openBlock(), _createBlock(_component_CreateEditEmailConfig, {
          key: 1,
          model: _ctx.formData,
          modelValue: _ctx.showCreateAddModal,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showCreateAddModal) = $event)),
          showDialog: _ctx.showEmailAddModal,
          selectedItem: _ctx.selectedForAction,
          onClose: _ctx.refreshList,
          onConfirmDiscard: _cache[4] || (_cache[4] = 
      () => {
        _ctx.showCreateAddModal = false;
        _ctx.showEmailAddModal = false;
      }
    ),
          onSubmit: _cache[5] || (_cache[5] = 
      () => {
        _ctx.showEmailAddModal = false;
        _ctx.refreshList();
        _ctx.showCreateAddModal = false;
      }
    )
        }, null, 8, ["model", "modelValue", "showDialog", "selectedItem", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ActivityModal, {
      refresh: _ctx.loading,
      icon: "las la-envelope fs-3",
      viewName: "Emails Activity Pulse",
      type: "2800"
    }, null, 8, ["refresh"])
  ], 64))
}